"use client";

import { cn } from "@/lib/utils";
import { CONTENT_LABEL_WRAP } from "../content-label-budget";
import { useLegendItem } from "./legend-context";

export interface LegendLabelProps {
  /** Label class name. Default: `"text-[13px] font-medium text-[var(--fg)]"` */
  className?: string;
}

export function LegendLabel({
  className = "text-[13px] font-medium text-[var(--fg)]",
}: LegendLabelProps) {
  const { item } = useLegendItem();

  return (
    <span
      className={cn(
        "inline-block leading-tight text-legend-foreground",
        CONTENT_LABEL_WRAP.label,
        className,
      )}
    >
      {item.label}
    </span>
  );
}

LegendLabel.displayName = "LegendLabel";
